import AddUser from "./AddUser";

const AddUserContainer = (props: any) => {
    const {  
        usersOption,
        userDetails,
        onChangeUserName,
        filterOptionUser,
        userSelectOnBlur,
        userSearchText,
        userById,
        userCreated,
        searchBy,
        onChangeSearchBy
    } = props
   
    return <AddUser
            usersOption={usersOption}
            userDetails={userDetails}
            onChangeUserName={onChangeUserName}
            filterOptionUser={filterOptionUser}
            userSelectOnBlur={userSelectOnBlur}
            userSearchText={userSearchText}
            userById={userById}
            userCreated={userCreated}
            searchBy={searchBy}
            onChangeSearchBy={onChangeSearchBy}
            />
}

export default AddUserContainer;